import Router from 'next/router'

import { API_BASE_URL } from '@/lib/constants'
import { enumsFromDTO } from '@/lib/types'
import { Article, Portal } from '@/lib/types/articles'

import { fetchAPI } from '.'

export async function findArticles(query: string): Promise<Article[]> {
  return await fetchAPI('GET', 'support/articles/search', { query })
}

export async function getArticle(id: string): Promise<Article> {
  return await fetchAPI('GET', `support/articles/${id}`)
}

export async function getPortal(): Promise<Portal> {
  return await fetchAPI('GET', 'support/portal', {})
}

export async function getDocumentsByName(name: string): Promise<string> {
  const language = Router.locale || 'en'

  const query = new URLSearchParams({ language })

  const response = await fetch(
    `${API_BASE_URL}support/documents/${name}.html?${query}`,
    { method: 'GET' }
  )

  return response.text()
}

export async function getEnums(): Promise<any> {
  const data = await fetchAPI('GET', 'enums')

  return enumsFromDTO(data)
}
